<template>
  <div class="academic-association topic-list">
    <div class="home-header">
      <van-search
        class="header-search"
        @click="$router.push({name:'search'})"
        v-model="value"
        placeholder="搜一搜"
      />

      <van-tabs v-model="activeTab">
        <van-tab title="标签 1"></van-tab>
        <van-tab title="标签 2"></van-tab>
        <van-tab title="标签 3"></van-tab>
        <van-tab title="标签 4"></van-tab>
        <van-tab title="标签 4"></van-tab>
        <van-tab title="标签 4"></van-tab>
      </van-tabs>
    </div>
    <div class="box" @click="handleTopic">
      <div class="top">
        <img
          class="logo"
          src="https://img1.baidu.com/it/u=1407750889,3441968730&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=799"
          alt
        />
        <div class="top-name">靶向专委会</div>
        <div class="more">
          更多
          <img src="../../../static/img/icon_more.svg" alt />
        </div>
      </div>
      <img
        class="big-img"
        src="https://img1.baidu.com/it/u=1407750889,3441968730&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=799"
        alt
      />
      <div class="content">市中心医院肿瘤综合科主任季有信教授介绍，各种靶向药物已成为多元化治疗不可或缺的组成部分。</div>
    </div>
    <div class="box">
      <div class="top">
        <img
          class="logo"
          src="https://img1.baidu.com/it/u=1407750889,3441968730&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=799"
          alt
        />
        <div class="top-name">靶向专委会</div>
        <div class="more">
          更多
          <img src="../../../static/img/icon_more.svg" alt />
        </div>
      </div>
      <img
        class="big-img"
        src="https://img1.baidu.com/it/u=1407750889,3441968730&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=799"
        alt
      />
      <div class="content">市中心医院肿瘤综合科主任季有信教授介绍，各种靶向药物已成为多元化治疗不可或缺的组成部分。</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeTab: 1,
      value: ''
    }
  },
  methods: {
    handleTopic () {
      this.$router.push({ 'name': 'topic-detail' })
    },
  }
}
</script>

<style lang="scss">
@import './index.scss';
@import '@/components/search-tab.scss';
</style>


// WEBPACK FOOTER //
// src/views/academic-association/index.vue